export default __webpack_public_path__ + "static/media/in_transit_false.93ed9b7f.svg";